import React from "react";
import usePageTitle from "../hooks/usePageTitle";
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

const Contact = () => {
  usePageTitle("Contact Us - Agrolinka");

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white rounded-lg shadow-sm p-6 md:p-8">
        <h1 className="text-3xl font-bold text-agBlack mb-2">Contact Us</h1>
        <p className="text-gray-600 mb-8">
          Have a question or need assistance? We're here to help! Reach out to
          us through any of our contact channels.
        </p>

        <div className="space-y-6">
          {/* Email */}
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-agBg rounded-full flex items-center justify-center">
                <FaEnvelope className="text-agGreen text-xl" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-agBlack mb-1">Email</h3>
              <a
                href="mailto:info@agrolinka.com"
                className="text-agGreen hover:underline"
              >
                info@agrolinka.com
              </a>
              <p className="text-sm text-gray-500 mt-1">
                For general inquiries and support
              </p>
            </div>
          </div>

          {/* Phone */}
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-agBg rounded-full flex items-center justify-center">
                <FaPhone className="text-agGreen text-xl" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-agBlack mb-1">Phone</h3>
              <a
                href="tel:+2348065165064"
                className="text-agGreen hover:underline"
              >
                +234 806 516 5064
              </a>
              <p className="text-sm text-gray-500 mt-1">
                Call us for immediate assistance
              </p>
            </div>
          </div>

          {/* Address */}
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-agBg rounded-full flex items-center justify-center">
                <FaMapMarkerAlt className="text-agGreen text-xl" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-agBlack mb-1">
                Office Address
              </h3>
              <p className="text-gray-700">
                13 Akure Street, War College Estate
                <br />
                Gwarimpa, Abuja
                <br />
                Nigeria
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
